import { httpRequest, endpoint } from "@cirrus/core/http"

export const itemGET = async (scheduleId) =>
  await httpRequest.get(endpoint.withRoot(`/api/delivering/${scheduleId}`))

export const itemAvailableCandidatesGET = async ({ pattern, scheduleId }) =>
  await httpRequest.get(
    endpoint.withRoot(`/api/v1/author/delivering/${scheduleId}/availableCandidates`),
    { params: { search: pattern } },
  )

export const itemCandidatesGET = async ({
  pageNumber: page,
  pageSize,
  print,
  scheduleId,
  sortBy,
  total,
}) => {
  // TODO : Add label and total pages params..
  return await httpRequest.get(
    endpoint.withRoot(`/api/v1/author/delivering/${scheduleId}/candidates`),
    {
      params: {
        page,
        pageSize,
        sortby: `${sortBy.sortId}+${sortBy.direction}`,
        // labels: filter.labels,
        print,
        total_entries: total,
        // total_pages: filter.totalPagesCount
      },
    },
  )
}

export const itemCandidatesAddPOST = async ({ id, scheduleId, type }) =>
  await httpRequest.post(
    endpoint.withRoot(`/api/v1/author/delivering/${scheduleId}/candidates/add`),
    { itemId: id, type, scheduleId },
  )

export const itemCandidatesAddReadyGET = async ({ scheduleId, sessionId }) =>
  await httpRequest.get(
    endpoint.withRoot(`/api/v1/author/delivering/${scheduleId}/candidates/add/ready`),
    { params: { sessionId } },
  )

export const candidatesInfoGet = async ({ scheduleId }) =>
  await httpRequest.get(endpoint.withRoot(`/api/delivering/${scheduleId}/candidates-info`))

export const itemCandidatesInfoGET = async (scheduleId) =>
  await httpRequest.get(
    endpoint.withRoot(`/api/v1/author/delivering/${scheduleId}/candidates-info`),
  )

export const itemCandidatesRemovePOST = async ({ scheduleId, selectedIds }) =>
  await httpRequest.post(
    endpoint.withRoot(`/api/v1/author/delivering/${scheduleId}/candidates/remove`),
    { selectedIds },
  )

export const itemCandidatesRemoveReadyGET = async (scheduleId, sessionId) =>
  await httpRequest.get(
    endpoint.withRoot(`/api/v1/author/delivering/${scheduleId}/candidates/remove/ready`),
    { params: { sessionId } },
  )

export const itemPrintPUT = async (scheduleId, candidateIds, { printPages, printQuestions }) =>
  await httpRequest.put(endpoint.withRoot(`/api/v1/author/delivering/${scheduleId}/print`), {
    candidateIds,
    printPages,
    printQuestions,
  })

export const itemPrintAnswerFormPUT = async (scheduleId, candidates) =>
  await httpRequest.put(
    endpoint.withRoot(`/api/v1/author/delivering/${scheduleId}/print/answer-form`),
    candidates,
  )

export const itemPrintReadyGET = async (scheduleId, sessionId) =>
  await httpRequest.get(endpoint.withRoot(`/api/v1/author/delivering/${scheduleId}/print/ready`), {
    params: { sessionId },
  })

export const itemUnlockPOST = async ({ scheduleId }) =>
  await httpRequest.post(endpoint.withRoot(`/api/v1/author/locking/${scheduleId}/unlock?type=4`))
